<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="员工业绩" />
    <basicList
      ref="table"
      :config="basicListconfig"
      @search="searchEvent"
    >
      <template v-slot:otherOperations>
        <el-button
          size="small"
          icon="el-icon-download"
          type="primary"
          @click="handleExportAll"
        >导出</el-button>
      </template>
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            @sort-change="sortChange"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            style="width: 100%"
            row-key="id"
            resizable
            border
            :show-overflow-tooltip="true"
            :height="basicListconfig.height"
          >
            <el-table-column
              width="80"
              prop="id"
              label="ID"
              sortable="custom"
              fixed="left"
            />
            <el-table-column
              width="120"
              prop="work_date"
              label="工作日"
              sortable="custom"
              fixed="left"
            />
            <el-table-column
              width="120"
              prop="user_name"
              label="员工姓名"
              fixed="left"
            />
            <el-table-column
              width="120"
              prop="shop_name"
              label="门店名称"
            />
            <el-table-column
              width="120"
              prop="turnover_trade"
              label="销售额指标"
            />
            <el-table-column
              width="100"
              prop="turnover_ratio"
              label="销售额占比"
            >
              <template slot-scope="scope">
                {{ scope.row.turnover_ratio ? scope.row.turnover_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="turnover_actual"
              label="销售额实际完成值"
            />
            <el-table-column
              width="120"
              prop="turnover_completion_rate"
              label="销售额完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.turnover_completion_rate ? scope.row.turnover_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="turnover_weighted_score"
              label="销售额加权得分"
            />
            <el-table-column
              width="100"
              prop="order_trade"
              label="订单数指标"
            />
            <el-table-column
              width="100"
              prop="order_ratio"
              label="订单数占比"
            >
              <template slot-scope="scope">
                {{ scope.row.order_ratio ? scope.row.order_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="order_actual"
              label="订单数实际完成值"
            />
            <el-table-column
              width="120"
              prop="order_completion_rate"
              label="订单数完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.order_completion_rate ? scope.row.order_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="order_weighted_score"
              label="订单数加权得分"
            />
            <el-table-column
              width="100"
              prop="profit_trade"
              label="毛利指标"
            />
            <el-table-column
              width="100"
              prop="profit_ratio"
              label="毛利占比"
            >
              <template slot-scope="scope">
                {{ scope.row.profit_ratio ? scope.row.profit_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="profit_actual"
              label="毛利实际完成值"
            />
            <el-table-column
              width="120"
              prop="profit_completion_rate"
              label="毛利完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.profit_completion_rate ? scope.row.profit_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="profit_weighted_score"
              label="毛利加权得分"
            />
            <el-table-column
              width="100"
              prop="sales_trade"
              label="动销数指标"
            />
            <el-table-column
              width="100"
              prop="sales_ratio"
              label="动销数占比"
            >
              <template slot-scope="scope">
                {{ scope.row.sales_ratio ? scope.row.sales_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="sales_actual"
              label="动销数实际完成值"
            />
            <el-table-column
              width="120"
              prop="sales_completion_rate"
              label="动销数完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.sales_completion_rate ? scope.row.sales_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="sales_weighted_score"
              label="动销数加权得分"
            />
            <el-table-column
              width="100"
              prop="stock_check_trade"
              label="盘库数指标"
            />
            <el-table-column
              width="100"
              prop="stock_check_ratio"
              label="盘库数占比"
            >
              <template slot-scope="scope">
                {{ scope.row.stock_check_ratio ? scope.row.stock_check_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="stock_check_actual"
              label="盘库数实际完成值"
            />
            <el-table-column
              width="120"
              prop="stock_check_completion_rate"
              label="盘库数完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.stock_check_completion_rate ? scope.row.stock_check_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="stock_check_weighted_score"
              label="盘库数加权得分"
            />
            <el-table-column
              width="120"
              prop="room_id"
              label="群聊ID"
            />
            <el-table-column
              width="120"
              prop="all_completion_rate"
              label="综合完成度"
            >
              <template slot-scope="scope">
                {{ scope.row.all_completion_rate ? scope.row.all_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="160"
              prop="create_time"
              label="创建时间"
            />
            <el-table-column
              width="160"
              prop="update_time"
              label="更新时间"
            />
          </el-table>
          <div class="table_footer">
            <p class="table_footer_total">共{{ basicListconfig.total }}项数据</p>
            <el-pagination
              background
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              @current-change="handleCurrentChange"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            />
          </div>
        </div>
      </template>
    </basicList>
  </div>
</template>

<script>
import { getSession } from "@/utils/cookie";
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import { employeePerformanceGetList } from "@/api/employeePerformance";
import {
  getshoplist,
  userGetlist,
} from "@/api/basicConfiguration";

const defaultParameters = {
  page: 1,
  limit: 10,
};

export default {
  name: "employeePerformance",
  data() {
    return {
      compId: null,
      shopId: null,
      userId: null,
      roleId: null,
      comp_level: 0,
      host: "",
      downloadUrl: "",
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        height: "calc(100vh - 290px)",
        search: [
          {
            label: "日期",
            type: "quickDate",
            key: "work_date",
          },
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "员工",
            type: "select",
            options: [],
            key: "user_id",
          },
        ],
        data: [],
        column: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.roleId = this.$store.getters.userRole;
    this.compId = this.$store.getters.userInfo.compId;
    this.shopId = this.$store.getters.userInfo.shopId;
    this.userId = this.$store.getters.userInfo.userId;
    this.comp_level = this.$store.getters.userInfo.comp_level;
    this.host =
      process.env.VUE_APP_BASE_API || "https://erp.zuizhenshi.cn";
    this.downloadUrl =
      this.host + "/admin/Employee_performance/export";

    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 排序事件
    sortChange({ column, prop, order }) {
      if (order) {
        this.basicListconfig.searchParameters.sort = prop;
        this.basicListconfig.searchParameters.order =
          order === "ascending" ? "asc" : "desc";
      } else {
        delete this.basicListconfig.searchParameters.sort;
        delete this.basicListconfig.searchParameters.order;
      }
      this.getlist();
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;

      employeePerformanceGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res && res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data || [];
          this.basicListconfig.total = res.total || 0;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res ? res.msg : '获取数据失败');
        }
      }).catch((error) => {
        this.basicListconfig.loading = false;
        console.error('获取员工业绩列表失败:', error);
        this.$message.error('获取数据失败：' + (error.message || '未知错误'));
      });
    },
    // 获取数据源
    obtainDataSource() {
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "shop_id") {
              item.options = res.data.map((list) => {
                return {
                  label: list.name,
                  value: list.id || list.shop_id,
                };
              });
            }
            return item;
          });
        }
      });

      userGetlist({ comp_id: JSON.parse(getRoles()).comp_id, limit: 100000 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((list) => {
                return {
                  label: list.name,
                  value: list.id,
                };
              });
            }
            return item;
          });
        }
      });
    },
    handleSizeChange(val) {
      this.basicListconfig.searchParameters.limit = val;
      this.getlist();
    },
    handleCurrentChange(val) {
      this.basicListconfig.searchParameters.page = val;
      this.getlist();
    },
    handleExportAll() {
      const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'https://erp.zuizhenshi.cn';
      let params = `comp_id=${JSON.parse(getRoles()).comp_id}`;
      
      if (this.basicListconfig.searchParameters.work_date) {
        params += `&work_date=${this.basicListconfig.searchParameters.work_date}`;
      }
      if (this.basicListconfig.searchParameters.user_id) {
        params += `&user_id=${this.basicListconfig.searchParameters.user_id}`;
      }
      if (this.basicListconfig.searchParameters.shop_id) {
        params += `&shop_id=${this.basicListconfig.searchParameters.shop_id}`;
      }
      
      const url = `${apiBase}/admin/Employee_performance/export?${params}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
/* 修复固定列遮挡水平滚动条导致无法拖动的问题 */
/deep/ .el-table__fixed,
/deep/ .el-table__fixed-right {
  height: auto !important;
  bottom: 10px !important;
}

/* 加深表格内滚动条颜色，使其可见 */
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #b0b7c0;
  border-radius: 5px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #7a828d;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/employeePerformance/index.vue